import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "./Investigations.module.css";

const getPageItems = (current, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = new Set([1, totalPages]);

  for (let page = current - 1; page <= current + 1; page += 1) {
    if (page > 1 && page < totalPages) {
      pages.add(page);
    }
  }

  const sortedPages = [...pages].sort((a, b) => a - b);
  const items = [];

  sortedPages.forEach((page, index) => {
    const previousPage = sortedPages[index - 1];
    if (previousPage && page - previousPage > 1) {
      items.push("...");
    }
    items.push(page);
  });

  return items;
};

const InvestigationsPagination = ({ current, total, pageSize, onChange }) => {
  const totalPages = Math.ceil(total / pageSize);

  if (totalPages <= 1) {
    return null;
  }

  const pageItems = getPageItems(current, totalPages);

  return (
    <div className={styles.paginationBar}>
      <button
        type="button"
        className={styles.navBtn}
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
      >
        <LeftOutlined />
        Previous
      </button>

      <div className={styles.pageNumbers}>
        {pageItems.map((item, index) =>
          item === "..." ? (
            <span key={`ellipsis-${index}`} className={styles.pageEllipsis}>
              ...
            </span>
          ) : (
            <button
              key={item}
              type="button"
              className={`${styles.pageBtn} ${
                item === current ? styles.pageBtnActive : ""
              }`}
              onClick={() => onChange(item)}
            >
              {item}
            </button>
          )
        )}
      </div>

      <button
        type="button"
        className={styles.navBtn}
        disabled={current >= totalPages}
        onClick={() => onChange(current + 1)}
      >
        Next
        <RightOutlined />
      </button>
    </div>
  );
};

export default InvestigationsPagination;
